import { createAsyncThunk } from "@reduxjs/toolkit";
import { corporateClientAPI } from "../api/corporateClientApi";
import { GetMarathonClientsParams, GetMarathonClientsResponse } from "../types/corporateClientTypes";
import { toast } from "react-toastify";

export const getCorporateClientsByMarathonId = createAsyncThunk<
  GetMarathonClientsResponse,
  GetMarathonClientsParams,
  { rejectValue: string }
>(
  "admin/getCorporateClientsByMarathonId",
  async (data: GetMarathonClientsParams, { rejectWithValue }) => {
    try {
      const response = await corporateClientAPI.getCorporateClientsByMarathonId(data);
      return response.data;
    } catch (error: any) {
      const errorMessage = error instanceof Error ? error.message : 'Ошибка на сервере';
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return rejectWithValue(error.response?.data || "Unknown error");
    }
  }
);